export const kCompressedDigraphs = `
H4sIAAAAAAAAA0WbaVMbSbNGfwsd4QCbBrSBJMwS7GBAMGIzzLzhELvY5AEEhl9/I8/JifvtZKs6n+zq
qqyt9fffReeoKCv/K/8uDjaLsgr8LMpawNrPoqwDh0XZAP4qyumApe2inAlY3inKJnBQlK2AzcOibAfs
rBdlFdfHh0VZxfd6XMP5Srcoq3g/2CvKKu4Ptoqyiv/VnaKsIrBaLcoqCqu1oqwisVovyioaq42irKHR
2S7KmvGfFmXNB1guyhoaK52irPkIu0VZQ+MgfkVjbaUoa2isHxRlDY2NIDS6B0VZR+MoSI39oqyj0Tkv
yrox7xVlHX9Lr0U5g9rcWFG2uWNqqijb3PF1oSjbRDUaRLnRkaJsc+/YSNQQP4+A/D7yNRCZ0cVA6ybq
1cD3lwJ9AVGfhr4c79TYOyChbHUCjT7que5rCA916+ggELVNELXNH4GoHXMVtf3VQNT2j+JFotaNN9mw
quK1NVA7iPfWQG11JRC1/XjDDdT2KYvaYUg0UFuhLGq7J4GoHWxEY0FtDVQtbptGbSNum/bZQNRWaGM2
gKi+adT2KGBN7gaitsRV1Drhdwa1kfAwg9rKayBq+5eBNrZhIGqnV4GoLS8HonawFoja6GwgaiuDQNQm
etHoUZubC0StEy+2idrERCBq3ZtAW9FjoI0xqqSJ2jhlUavFUzRRq4OojY5Gx0Jt9yMQtf14zBZqk1El
LZtsGYhaNTy0UJuI0FuoLSwEolZtBKJWpe+iVo+rbdQWQ8LusRRt3f6xFOHYQZbCmT1kKZp92+QTdWZv
WYpG20ZtKSq1bU1GkG3U1kYiQdhKRgNRW1sINEfMBqK2RVnUtiiL2hZlUduirMloIhC1zmIganvhwZy3
Fx5Menvhway3F2VNe3vhzLz3LTKuiW9vKhC1I5yhdoQz1I5whtpReDD7nUYB09/hZiBqLy+BqPXCmbmk
R1nUeuHMXNKLyMwlPfyi1usFota7imSK2kUZiNpV+DWXXIVfc8lV+DWXXIUzc0mfsqj1KYtan7Ko9SmL
2mXUr7nkKSIzlwzCg7lkEB7MJYPwYC4ZUBa1QTgzl0yAqA2ifs0lQ5yhNgxn5pJhODOXDOM2c8kHBVB7
vQ1E7YMCtsmI11zSA22TY4HWJIja0vcYeFDrgeaSkDCXXIDmkgjHXHIBorYyGYjaBWienAtE7QJ0iAw0
l1yCqK1GPZhLLkEH+gjdXHIForYWoZtLrkDU1kLYXHIF2t/igcwlV6D9LYTNJVcgahvxQOaSGxC1jZAw
l9yAqG2EhLnkBkRtIxqiueQGRG0znJlLbkHUNuMxzSW3oL07Goy5pA+ithUPby7pg6htjcVEALU+6Gj6
PRC1PmgumQxErQ+q9iNQtbtA1H4sBKJ2B6K2XcZkA7V7ELX7+0DUdkYDUXsAUduhLGoPIGo7c4GoPYCo
7URk5pKHQHPJzlQgag+gM4WQMJc8gah1QsJc8gSi1gkJc8kTiNroU6Cj6UZR1s0lTzeB5smJQHs3aJ6M
qjaXDEDz5D9FMHIDGb29tUD0BleBTuEiYrPJM4heNyI2mzyDjqcRsdnkGXSuwG3IvYCoHcTrMpu8gM5M
wpnZ5AV0ZhLOzCYvIGqHFEDtFUTtkAKovYKoHcbbMJu8go4CizHtNHeBqB1FBZpNhiBqR1GBZpMhiNpR
JRC1IeiYQ62aToayetHIzSdDEL2TeHzzyTuI3ilorgTRO50NRO8s6tJ88gkidxaN0XzyGWg+OYuaMJ98
go6o7aJs2MgHoM1gK9Bm0A/E2cdzUTZszkdR1mY3BLl6NhVoOCAe1lYDTd1zRdmwhnsgt22BPHEf5In3
QMci0FEdRGIIOtOsFmXDh++BqjWLsuHD90CnSvVAhHugyTTizWQKmkxDIpMpiPA2iNo96OTle1E2TKYD
0E4Z4ZhMB6ADxVmgA8VnIGp34cxkujFalNPmyhsQZ98PirJpghydK8qmOW10rCibmSMmA52VVoqyaY4Y
/R5o2WiJTTPD0peibOcsDnTKDZpuQSf4oDOoQBPrCYjjfj3QCei3QCSWQfxugE6uQZeOILV6BiJxCvIY
m4Em1i0QtW3QNA6itguaWEEHe9CnAF2mgKh1QVNPoDV1CNrYQSTWQSR+gkj8BSJxAjougUgcg84Do87M
pVcgah+goyCI2jAq1VzaCw/m0nPQRgmidgk6nwDt/4Hm0g8QtVtQNRC1exC1BxC1RxC1JxC1C9AEAaL2
O9Bc+gyi9u0l0MzNVeeBoLkURO0aRO0PiNq/IGrvIGp3gWbSN9A5blSfmXQIovYOusrbKMq2Pb0EHTKi
qu3pryDCuyDCj6BTi0B7+j3ogg9E+DdoP/0Suzh2jLs67AQnFqMVW+gqZWyiG7LTqDXYPZsD2IlUrPsq
9u1TmQh+cK9tducHjFZH5pEPX2B0t72O7rH3qnUGm0Png22vyzJax7I7BbIbE7L7IDJaZ/i31Z553WeU
0f0hW8ewLXdHRndXdk4lO82R3RGR0e3K7hvITgZkM5qM7jpsG96UXV7I7r3xLDbjA9n9twsY3flItNWK
TfnUmxH+kj/4xLxhm/OP2P6p2J5/LMEOlNxsiz6XUX6THbJklC9l1xuyIzKROkh+eh3dPuwweSc7VZbR
fZDRfZTRfZIdpGV0f8voPsvO8mR0X2G70VBG91p2/SGjeyG7luNZHDVfZOeWvAEXIfOjMLof3ovul7he
dWy9u4LRvRvC9tQe7JRkAFu3X2Bzr+wiXD9oXb7A1m0/2MHyQ1aLe80KD3ewSwPZ+Sx+HDHvvY7um/eq
9QmjdRrZpeqg+CHbM2CzxUB2L1nGz7WMn2PYHv8m2wNge96F7MwJtj3fyGaOcbYdub4su+iEfe+rsstO
Gf8nMv7PZMdc2Yx9B1MnP7zu7OwLjO62191PH2fD0326L7AZxetmFK+bNb1uz5Zdzsvo7lveGYXXnYHf
weie/WB3Fd2/KGMb6Mru7N7CLmm87gAFmx2/w2adRRndzVHYyQWbr+aQ3iaM1rvspBctc8iH151h4NMc
ci47HD7CaL163TXUPYzuDdfNIbdcN4f88br7JDK6l5Zxleh1dD9l+7KM7ssT7N6M193mumSHGd1X6ty2
9Mlz2ZauKG9b6svojo+zJc291zL3/itz773sJoHMvY+yC3eZmG9lYn6X3ZeQXUXBtodZGd1/Cg2E52WE
p2QnLzLCVRnhuoxwRXY1xL67Deg31x3C3sbZIXeBcc0WOUFU2Dn3xVdld75lt75lHqYB++KnZfzMyGg1
ZZ6lJfMsbdnd/Vi4zFj+XHYB8QsmnnPZ/WPK+OIvZfflKOMLvpSdYpUwfi5lD6zi3qYv41rGz8YETDw3
srtglnEbTPacZxamfm5lly+h1XT9ciu7gBmFXUPKTnsi5qZTuHsZ3R2Z8g8y5Xe512nYo+xSiNichj3K
xNmR8fMku6OET5P7k4yffXw6vfkte9LEvc5ufsvUZ1fG/7PsDhI+TTTPsvtClLG9vchOz+Ccj8te597s
8LLT0cWibLbsnG8y/k9GYJcOMvGcxLO0fO/vsvsws7AbMTL1cDIJ4/9dxv9PGf9/ZPz/5F7f+x8Z/6eU
yUFadpBbgPH/KTtt/gU7aZPxfws7qL/i30H9vQLrX3atXwu2nfRkNyJg3+OV7O40deh7vJJdelDG/t6X
3eaQ3UeS3QULzt2CoWw9xLvIFfyH7I4XZVwKfcj4OV2EnczJxPM93l0uvUuZ8t/xaX8pZcovxlZILr8X
S5h4RmZh4lmUiafaKcpWHqFVd2HeS11GtyGjOyN7aHdYlK08Matuwh4+VmHKTIT/POea2IUtU4c9x67B
xDAve5I9AxPDaBsmhkkZ/+1RmGf/p+AGG+U/BaVslbMyyu1Yn7Ty2GtqAkZ6ah52rj+AkZ6chJEoYZvl
l0qwVV0lDKu3JuO/LuO/ATusVA3CnFVLw4EuDU9sejBPOketms0WYBePsz9hd794HBeJU9fBLvQq8fFF
Hjc0ZHxOy/icgW3JTRmfLdm6k3m0cRmfE7ILQ9mPFWSe5atsZpbRrbwE+9KqMro1Gd26jG5DRndaRndG
Rrcpo9uSbS0yuuOwr3JCRndeRndMRver7CFKP9hF9/4rbNaNJpQ77GtD2FbdDTaTzO//Pw9WirLV8N1d
DGBPLNdh4u9EM2s45d3fg51e/4F5roPoWbkTfCi7+f0IexTOvY4m1eh90z5vTaZ8dRomhppM/HWZem7I
zqBmYOKcls0MLdjzfNhuMi2j25TV7cJo1WSzkGwWktWS0ZqR0WrC9ouWjFZbdnSQecZz2SW37MzzOdi+
U5PxU5fx05DxMy3jZ0bGT1Mm/pZM/G3ZGaxM/Oew7/pCRncu+nVO9ydGYHQnFmD74BuM7pzXPVBYhdGd
i/Y5Y7udX4CJYZ7rPu/6UlG2muaKy33YD27WYPxMVWDPj7lu3ugsw8Q8NgEb81eY2L7h074/fhZsf5+o
wZYfh3nGb/ixL++dw7Z52dlXjER5GFAZg7m3Qpy24Ykd2O9RjmH7L/HYJpc6sNsKXZh7x45g7v0q+8HH
E+yMfQsmtq3oy03b4eQsTPnZSZjys/i3/mct4wgeuT1npCsbMPcuUg+2h8V52KUy9eYMc34x2DywSTzO
UkaifMvV0HwdNhfNwWgtWMb28y3Yd/ptAXYWQXlz/ojXKT8WeaxlPX+Vvf4L5hm/yub8qIeW9VCpwc4W
4j3mTGwy3kvbOGcj5py9TMrO7m6D7Y9zTRg/C7I5IWLObfTmAuzXUluw49QSzL2H8V7a5uetyOG55731
AKM7Fx/rVYxtagGmzPELpzLm2FsOYNCty+Zb2RwiOxO7g4mnJlM/dZnYGrJTiEmOZ5xyyE45ZMd6mXcx
LeN/RsZ/U8Z/S8Z/GzYn3N5yDIPW5ibsFu0bjNbxMWzenoCd0PyCfZYR2FX2FOwqm/LWVYPy1lWD8llX
lM/tlWfYHNWFXQV73Y8fve7Z0QPsluIObO7iuqutnVXYI1/8+N6H+PG9H3kd3SOvozvUj0fk+DffHnnd
TXivo/v2zKmVW5Bd2FWe161Pr+Pn7QHGz9sO7FYm182xx1y3P17ewu4GbMI+L9eda61y3Rw79LqHVV43
fq8bP9edM7xx3TnDm9fRPfa6R4JcNzeur3Ka5k6I7JiyzHma9S8Tw7rsbgDsM3Zlp+UHsLlUpvyizPNe
w8a5J/sNxx6MVvcZ9jBlHcZ/9xR21b8Je5p6BjvubHPG5yetP2Hq54U486PWLuyRP1qOI0eHHAq6cpQ9
ZqO8/feQ8vbf1VdODt0Rorxzkv0d2PIPsOXPOV70Xb/DlN8hfvts5RGmfGUA84yVXdhcjX/7ZoXY7JsH
T7Dj3QXsAdMlB5hui8tc/1bjsNIxvQr7CXTUbY6PC7IxDINtJ5Uj2G9qZMqsR/xN++nuA+xcLt517jZc
bMI848Uq7IdxK7DHoBFn7iTstmDu3a3B3Lt7Dlv+D+wnxz9hP5HYjmOYivupP39qcMeEhk13KzYta5nT
y18aDnoaZqRxTtJq+dXaeP7Ew35LA6HvafhK03AcH9dwUEwDoblRPiO36y2k4VxT1fxkbeE/C6Wx/yxH
+v8s132HGk5Efmnw7GPp3mlAGkQxtoXhRONrGs4GFzVcukxjOL710vA73DT8fjQNp71p+CVNGn6ukwYR
XGnYrfbScG2WhluVPQ0iuEmDCO77GkRwkwYR3A81iOAmDTdErzQ8WtCwo94PNIjgJg2/LFDUcfczDSJ4
UdRe/JmGG46K5vFoGp5TpqjfUGjYxV8Uze+o0iCCV0VzBE7DkzxFze+Xabi1eaTh4YoR5DCchkelRpDb
3WkQwasR2Oov0/Ao0Qhs9U+K2uqfdO1w/JTe/NowHbiNnQ5ceWE07A+/0/Bbkr6GW/dpEMHvNNwsH2p4
vJSG28dpEMHtlQYRnKfhtyUa9oXbgQYRnKfhpxdpeFRtoE7IHw3HGcCjovafx3RNBI/pwK3GJQ0PbvTm
9ODjSMOvd/SW25l7Gh6w6c1U+5wOiODZcEy2z+nAA3PDcVrxnA6I4N1wXMi96y33ffXmUP6uA/P1uw5M
2E/TGkTwpqjD+T+FP7lwqKTh5/VpcNN4Gn6qPaPhea+GI3Y/DZcJaThfTMMJYxp+CZeGp6xpuKOchovc
NDzgtRJMVhsaJqtta8RktZEGEWz73CarjTSIYNuKM1ltpEEE29aiyWojDdfZKepZr4bJ6kBRk9VZGs55
FDVZnaXhQbOiJquzNPx4RVGT1VkarshS1CmsRu51KWqyWk2DCA5tviarQyMwWa2m4Rm7EeSKIQ0PYozA
ZLWahkdJRmCy6ihqsuro2mTV0ZvJqqMDk9VmOnA6nIZ7EWl47p2unUml4R+pMHL9sDnUIILlNPzLURoe
7F1pEMFyGh51peGfuAYa/mcvDf/IlYbHcgSah/67hmOy2lXUZLWra5PVrg5MVqdLGn7wm978luhIw2OR
9OZXk3safg2iN5NVVwcmq67hmKy6OjBZdQ3HZNVNBx6jGY7J6iS9EcFJeiOCk3TgZq8O8u9zMxou4xQ1
WW3r2mS1vabhCk+dXDqpkx+rqZN/pksdIphMHf8GpuH641saThbTcNBqaDjMaJjFHtPwu6Q0HGrT8FPG
NEyxafgXgjT8YCgNor5Pw6E2DT9r1DCL/ZuGX1OkQQSftxp+G5WGE540HGbyHiL4TMNPONNwwpOGX5Fo
mMUGafh3pTTcKfaV5P9d0vB/Ub5gE9cgDf8b9aThwWIainYw8r8vaSj6rOH3qkZg4hqm4f9E1DFxveUv
znE2NJxpKpr/q4vvxWp5XlpLw22iNNwnSsONojTcKUrDraI03CtKw80iDVvi9XX8vTX/7XTd18DB9YOG
32TxL9j8d9NLGrX//e//AJ/qgvx1PAAA`;
